import { Checkbox } from "@/components/ui/checkbox";

// Separate, unticked consent for optional emails (never bundled with Terms acceptance).
export const MarketingOptIn = ({ checked, onChange, testId = "marketing-opt-in" }) => (
  <label htmlFor={testId} className="flex cursor-pointer items-start gap-3 rounded-2xl bg-white/60 p-3 text-left ring-1 ring-slate-200">
    <Checkbox id={testId} data-testid={testId} checked={checked} onCheckedChange={(v) => onChange(v === true)} className="mt-0.5" />
    <span className="text-[13px] leading-relaxed text-slate-600">
      I'd like to receive occasional emails from FioNova with helpful wellness insights, product updates, and encouragement. I can unsubscribe anytime.
    </span>
  </label>
);
